<ba-bub-error404
  buttonText="Zurück zur Studiensuche Startseite"
  (buttonClicked)="navigateToHome()"
></ba-bub-error404>
